export default (userId, roleId) =>
  new Promise((resolve, reject) => {
    window.axios
      .delete(`${process.env.VUE_APP_API_ADMIN_LOCATION}users/${userId}/roles/${roleId}`)
      .then(() => {
        resolve();
      })
      .catch((error) => {
        reject(error);
      });
  });
